export enum Ability {
  answer = "answer",
  create = "create",
  decline = "decline",
  delete = "delete",
  duplicate = "duplicate",
  manageFastTrack = "manageFastTrack",
  manageFunders = "manageFunders",
  manageLenderNetwork = "manageLenderNetwork",
  markAsGlobal = "markAsGlobal",
  moveStages = "moveStages",
  run = "run",
  runAny = "runAny",
  update = "update",
  updateBillingType = "updateBillingType",
  updateManagedByLendflow = "updateManagedByLendflow",
  updatePrimaryScorecard = "updatePrimaryScoreCard",
  updatePrimaryScorecardGroup = "updatePrimaryScoreCardGroup",
  updateRelationship = "updateRelationship",
  updateStatus = "updateStatus",
  updateWorkflowSegment = "updateWorkflowSegment",
  view = "view",
  viewAny = "viewAny",
  viewBillingType = "viewBillingType",
  viewManagedByLendflow = "viewManagedByLendflow",
  viewFastTrack = "viewFastTrack",
}

export enum PermissionSubject {
  aiAgent = "AiAgent",
  application = "Application",
  applicationImport = "ApplicationImport",
  applicationNote = "ApplicationNote",
  bankAccount = "BankAccount",
  borrowerPlatformTemplate = "BorrowerPlatformTemplate",
  business = "Business",
  businessNote = "BusinessNote",
  businessProfile = "BusinessProfile",
  checkoutSnapshot = "CheckoutSnapshot",
  checkoutTemplate = "CheckoutTemplate",
  client = "Client",
  consentTemplate = "ConsentTemplate",
  contractTemplate = "ContractTemplate",
  dataOrchestrationLog = "DataOrchestrationLog",
  dataOrchestrationTemplate = "DataOrchestrationTemplate",
  documentTemplate = "DocumentTemplate",
  discoveryCallQuestion = "DiscoveryCallQuestion",
  documentVerification = "DocumentVerification",
  docusignTemplate = "DocusignTemplate",
  file = "File",
  filter = "Filter",
  funder = "Funder",
  fundingTransaction = "FundingTransaction",
  individualProfile = "IndividualProfile",
  lenderPlacement = "LenderPlacement",
  notification = "Notification",
  ocrolusBook = "OcrolusBook",
  offer = "Offer",
  offerNote = "OfferNote",
  offerTemplate = "OfferTemplate",
  ownershipSnapshot = "OwnershipSnapshot",
  permissionsPreset = "PermissionsPreset",
  personalTaxReturn = "PersonalTaxReturn",
  scoreCard = "ScoreCard",
  scoreCardBacktestReport = "ScoreCardBacktestReport",
  scoreCardGroup = "ScoreCardGroup",
  stip = "Stip",
  workflowTemplate = "WorkflowTemplate",
}

export enum UserType {
  lendflow = "lendflow",
  client = "client",
}
